import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const KEY = "svi_gdpr_consent_v1";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => {
      const consent = localStorage.getItem(KEY);
      if (!consent) setVisible(true);
    }, 800);
    return () => clearTimeout(t);
  }, []);

  const decide = (value) => {
    localStorage.setItem(KEY, JSON.stringify({ value, ts: new Date().toISOString() }));
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 left-4 right-4 md:left-6 md:right-6 z-[200]"
          role="dialog"
          aria-label="GDPR cookie notice"
          data-testid="gdpr-banner"
        >
          <div className="mx-auto max-w-5xl border border-white/10 bg-ink-900/95 backdrop-blur-xl">
            <div className="flex items-center gap-2 border-b border-white/10 px-4 py-2 bg-white/[0.03]">
              <span className="w-2 h-2 rounded-full bg-spectrum-green animate-pulseGlow" />
              <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/60">
                Privacy notice · GDPR
              </span>
            </div>
            <div className="px-5 py-5 md:px-6 md:py-6 grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 items-start">
              <div className="md:col-span-8">
                <div className="font-display text-lg md:text-xl font-bold text-white mb-2 tracking-tight">
                  We keep things minimal.
                </div>
                <p className="text-white/60 text-sm leading-relaxed">
                  This site uses a single essential cookie to remember your consent
                  choice and, for admin users, to hold an authenticated session. We
                  do not use tracking, advertising, or analytics cookies. Investor
                  and prospectus enquiries you submit are stored in our database
                  under Swedish law. Read more by writing to{" "}
                  <a
                    href="mailto:erik@svenskainvest.com"
                    className="text-spectrum-green hover:underline"
                  >
                    erik@svenskainvest.com
                  </a>
                  .
                </p>
              </div>
              <div className="md:col-span-4 flex flex-col sm:flex-row md:flex-col gap-3 md:items-stretch">
                <button
                  onClick={() => decide("accepted")}
                  className="h-11 bg-spectrum-green text-ink-950 hover:bg-white font-mono text-[11px] uppercase tracking-[0.25em] transition-colors px-4"
                  data-testid="gdpr-accept"
                >
                  Accept essential
                </button>
                <button
                  onClick={() => decide("declined")}
                  className="h-11 border border-white/15 text-white/80 hover:border-white hover:text-white font-mono text-[11px] uppercase tracking-[0.25em] transition-colors px-4"
                  data-testid="gdpr-decline"
                >
                  Only strictly necessary
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
